module.exports = __webpack_public_path__ + "static/img/track_en_blue.ef232c67.png";